import CaseGradingContainer from './CaseGradingContainer';

export default CaseGradingContainer;
